export default [
  {
    path: "/influencers",
    component: () => import(/* webpackChunkName: "users" */ "./layout"),

    children: [
      {
        path: "/",
        name: "influencers",
        component: () => import(/* webpackChunkName: "users" */ "./all"),
      },
    ],
  },
];
